import { Fragment, useState, useEffect, useMemo } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import Footer from "src/components/common/frame/footer";
import magnifierImg from "src/img/magnifier.png";
import { useMyStore } from "src/components/main/mainStore";
import {
    weeknum, 
    round, 
    getDatefromWeekNum, 
    getDateEndFromWeekNum2, 
    getDateEndFromWeekNum, 
    weekDays, 
    exclusiveOutisdeKeys, 
    numberReducer, 
    simpleStatusColorCode, 
    MyDate, 
    myAxios, 
    MyFormData, 
    scroll, 
    testerEmails, 
    convertAMPM, 
    convert24, 
    calculateDistance, 
    OfficesLocationMap, 
    officeTimeCardWeeks as weeks, 
    runnerExceptionEmailList, 
    arrayReducer, 
    timeDurationCalc, 
    getTimeStamp, 
    boolAndReducer,
    appTitle
} from "src/components/common/functions";
import Export from "./export";
import MapRange from "./mapRange";
//--------------------------------------------------------------------------------------------
export default function AllTimeCard({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const title = "AllTimeCard";
    const [mapRangeKey, setMapRangeKey] = useState("");
    const locationToAddress = locationArr => {
        if(!locationArr) return;
        for(let [name, [lat, lng]] of Object.entries(OfficesLocationMap)){
            if(calculateDistance(lat, lng, locationArr) < locationArr[2] / 1609.34){
                return name;
            }
        }
        if(locationArr[2]){
            return `(${round(locationArr[0], 3)}, ${round(locationArr[1], 3)}), ${(locationArr[2] / 1609.34).toFixed(2)} miles`;
        }else{
            return `${round(locationArr[0], 3)}, ${round(locationArr[1], 3)}`;
        }
    }
    const fD = async() => {
        const formData = new MyFormData();
        formData.append("userEmail", idid);
        formData.append("password", user.password);
        formData.append("wk", wk);
        //---------------------------------------------
        setShowLoading(true);
        const res = await myAxios("timeCard/readOneTimeCard.php", formData);
        setShowLoading(false);
        if(!res) return;
        //---------------------------------------------
        return res.data || {};
    
    }
    //--------------------------------------------------------------------------------------------
    const csvExport = async () => {
        const formData = new MyFormData();
        formData.append("week", wk);
        setShowLoading(true);
        const res = await myAxios("timeCard/csvExportTimeCard.php", formData, "blob");
        setShowLoading(false);
        if (!res) return;
        saveAs(new Blob([res.data], { type: "text/csv" }), `timecards_${wk}.csv`);
    };
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [isEdittingTime, setIsEdittingTime] = useState(false);
    const [statusFilter, setStatusFilter] = useState("");
    const [comments, setComments] = useState("");
    const [reportsList, setReportsList] = useState([]);
    const [forms, setForms] = useState([]);
    const [defaultForms, setDefaultForms] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    const [wk, setWk] = useState(() => {
        return location.pathname.split("/")[2] || weeknum((new MyDate()).s())
    });
    const idid = location.pathname.split("/")[3];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const validForms = useMemo(() => forms
    .map(allForms => allForms[0])
    .filter(currentWeekForm => 
        (getDateEndFromWeekNum2(currentWeekForm.week) > currentWeekForm.hireDate.replace(/-/g, "/")) &&
        (currentWeekForm.quitDate?getDatefromWeekNum(currentWeekForm.week, 0).replace(/-/g, "/") <= currentWeekForm.quitDate.replace(/-/g, "/"):true) &&
        (
            user.allOffice === "yes"?
                (currentWeekForm.outside !== "runner" || runnerExceptionEmailList.includes(currentWeekForm.email)) || testerEmails.includes(user.email)
                :
                (
                    user.allOffice === "runners"?
                    (currentWeekForm.outside === "runner" || testerEmails.includes(user.email))
                    :
                    (
                        user.allOffice === "all"?
                        true
                        :
                        false
                    )
                )
        )
    ).filter(allForms => statusFilter?(allForms.status === statusFilter):true)
    ,[forms]);
    const filteredValidForms = validForms.filter(u => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)) 
    );
    const currentForms = filteredValidForms.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredValidForms.length / itemsPerPage)}, (dummy, pageIndex) => (pageIndex + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const id = history.location.pathname.split("/")[2];
        const idid = history.location.pathname.split("/")[3];
        const getData = async() => {
            //---------------------------------------------
            setShowLoading(true);
            const resReports = await myAxios("timeCard/readReports.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resReports) return;
            setReportsList(resReports.data);
            //---------------------------------------------
            const formData = new MyFormData();
            formData.append("week", wk || weeknum((new MyDate()).s()));
            //---------------------------------------------
            setShowLoading(true);
            const res = await myAxios("timeCard/readAllTimeCard.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //---------------------------------------------
            const ordered = res.data.map(u => Object.keys(u).sort().reduce(
                (obj, key) => {
                    if(exclusiveOutisdeKeys.includes(key)){
                        obj[key] = u[key];
                        return obj;
                    }
                    obj[key] = u[key]?
                        {
                            ...JSON.parse(u[key]), 
                            email: obj.email, 
                            hireDate: obj.hireDate, 
                            quitDate: obj.quitDate, 
                            userName: obj.userName, 
                            outside: obj.outside
                        }
                        :
                        {
                            form: Array(7).fill({inOut: [], notes: ""}), 
                            email: obj.email, 
                            hireDate: obj.hireDate, 
                            quitDate: obj.quitDate, 
                            userName: obj.userName, 
                            status: "Created", 
                            outside: obj.outside
                        }
                    ;
                    return obj;
                }, 
                {}
            ))
            const curForms = ordered.map(o => Object.entries(o).filter(entries => !exclusiveOutisdeKeys.includes(entries[0])).map(([key, value]) => ({...value, week: key})));
            setForms(curForms);
            setDefaultForms(curForms);
            if(!weeks.includes(id)){
                setWk(weeknum((new MyDate()).s()));
                history.replace(`/${title}/${weeknum((new MyDate()).s())}`);
                return;
            }
            setWk(id);
            const thisWeekCurForms = curForms
            .map(allForms => allForms.find(cc => cc.week === id))
            .filter(currentWeekForm => 
                (getDateEndFromWeekNum2(currentWeekForm.week) > currentWeekForm.hireDate) &&
                (currentWeekForm.quitDate?getDateEndFromWeekNum2(currentWeekForm.week) <= currentWeekForm.quitDate:true)
            );
            const hashkeys2 = thisWeekCurForms.map(allForms => allForms.email);
            if(hashkeys2.includes(idid)){
                history.replace(`/${title}/${id}/${idid}`);
                setCurrentPage(Math.ceil((hashkeys2.indexOf(idid) + 1) / itemsPerPage));
                setTimeout(() => {
                    scroll(idid);
                }, 200);
            }else{
                history.replace(`/${title}/${id}`);
            }
        }
        getData();
        return () => {isMounted = false;}
    }, [wk, history, updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    All Time Card
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {weeks.length?<>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">Week:</label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        onChange = {e => {
                            setWk(e.currentTarget.value);
                            history.push(`/${title}/${e.currentTarget.value}`);
                            setCurrentPage(1);
                        }}
                        value = {wk}
                    >
                        {weeks.map((week, weekIndex) => <option key = {weekIndex} value = {week}>{getDateEndFromWeekNum(week)}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "status" className = "mb-0">Status:</label>
                    <select
                        id = "status"
                        className = "form-control w-auto ml-2"
                        onChange = {e => {
                            setStatusFilter(e.currentTarget.value);
                            setCurrentPage(1);
                        }}
                        value = {statusFilter}
                    >
                        <option value = "">All</option>
                        <option value = "Created">Unsubmitted</option>
                        <option>Submitted</option>
                        <option>Approved</option>
                    </select>
                </span>
                </>:<></>}
                <Export
                    forms = {forms}
                    wk = {wk}
                />
                <span className = "pointer" onClick = {csvExport}>CSV Export</span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredValidForms.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead>
                            <tr className = "noBorderTop">
                                <th></th>
                                <th>Name</th>
                            </tr>
                            </thead>
                            <tbody>
                                {currentForms.map((renderedForm, renderedFormIndex) => 
                                <Fragment key = {renderedFormIndex}>
                                <tr id = {renderedForm.email} className = "pointer"
                                onClick = {e => {
                                    if(!e.target.id){
                                        if(idid !== e.currentTarget.id){
                                            scroll(e.currentTarget.id);
                                            setIsEdittingTime(false);
                                            history.push(`/${title}/${wk}/${e.currentTarget.id}`);
                                            setComments(currentForms.find(allForms => allForms.email === e.currentTarget.id).comments ?? "");
                                        }else{
                                            scroll(null);
                                            history.push(`/${title}/${wk}`);
                                            setComments("");
                                        }
                                    }
                                }}>
                                    <td className = {idid === renderedForm.email?"showMinus":"showPlus"}></td>
                                    <td>
                                        <strong style = {{color:simpleStatusColorCode[renderedForm.status]}}>
                                            {renderedForm.userName}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td className = "noborder" colSpan = {100}>
                                    <TransitionWidthHeight 
                                        classNames = "cssTDTransition"
                                        In = {idid === renderedForm.email}
                                    >
                                        <form
                                            className = "border border-primary rounded p-2"
                                            onSubmit = {async e => {
                                                e.preventDefault();
                                                const formData = new MyFormData();
                                                formData.append("userEmail", idid);
                                                formData.append("currentWeek", wk);
                                                const thisForm = forms.find(allForms => allForms[0].email === idid).find(form => form.week === wk);
                                                thisForm.form = thisForm.form.map(day => 
                                                    ({
                                                        ...day, inOut:day.inOut.map(io =>
                                                            ({
                                                                ...io, 
                                                                in: io.in?.replace(" ", " "),
                                                                modifiedIn: io.modifiedIn?.replace(" ", " "),
                                                                out: io.out?.replace(" ", " "),
                                                                modifiedOut: io.modifiedOut?.replace(" ", " "),
                                                                duration: 
                                                                (
                                                                    (io.modifiedIn || io.in) && 
                                                                    (io.modifiedOut || io.out)? 
                                                                    round(
                                                                        (
                                                                            (
                                                                                new Date(`2021/05/21 ${(io.modifiedOut || io.out).replace(" ", " ")}`)
                                                                            ) - (
                                                                                new Date(`2021/05/21 ${(io.modifiedIn || io.in).replace(" ", " ")}`)
                                                                            )
                                                                        ) / 3600000, 2)
                                                                    :undefined
                                                                )
                                                            })
                                                        )
                                                    })
                                                );
                                                
                                                formData.append("data", JSON.stringify(thisForm));
                                                //----------------------------------------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("timeCard/updateOneTimeCard.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //----------------------------------------------------------------
                                                setIsEdittingTime(false);
                                            }}
                                        >
                                            <div className = "row">
                                                {weekDays.map((renderedDay, renderedDayIndex) => 
                                                <div className = "col-lg" key = {renderedDayIndex}>
                                                    <div className = "h4 text-secondary">{renderedDay} ({getDatefromWeekNum(renderedForm.week, renderedDayIndex)})</div>
                                                    {isEdittingTime?
                                                    <div>
                                                        <span className = "btn btn-success m-1" onClick = {() => {
                                                                    setForms(
                                                                        forms.map(allForms => allForms[0].email === idid?
                                                                        allForms.map(form => form.week === wk?
                                                                        {
                                                                            ...form, 
                                                                            form: form.form.map(
                                                                                (
                                                                                    (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                    ({
                                                                                        ...day, 
                                                                                        inOut: [
                                                                                            {m: true},
                                                                                            ...day.inOut
                                                                                        ]
                                                                                    }):day
                                                                                )
                                                                            )
                                                                        }:form):allForms)
                                                                    )
                                                        }}>Add To Below</span>
                                                    </div>
                                                    :<></>}
                                                    {renderedForm.form[renderedDayIndex].inOut.map((renderedIo, renderedIoIndex) => <div key = {renderedIoIndex} className = "p-2 mt-2 border rounded">
                                                    <div>
                                                        <span className = "font-weight-bold" style = {{color:renderedIo.m?"red":undefined}}>In</span>: <span style = {{textDecoration: renderedIo.modifiedIn? "line-through":undefined}}>{renderedIo.in}</span>
                                                        {renderedIo.modifiedIn?
                                                        <>
                                                            &nbsp;
                                                            <span className = "text-danger">
                                                                {(new MyDate("2021/05/21 " + renderedIo.modifiedIn)).ss()}
                                                            </span>
                                                            {renderedIo.modifiedInNotes?<div className = "text-danger cssNotes">
                                                                {renderedIo.modifiedInNotes}
                                                            </div>:<></>}
                                                        </>:<></>}
                                                    </div>
                                                    {!renderedIo.m && renderedIo.inLocation?
                                                     <div className = "mt-2">
                                                        <span className = "font-weight-bold">Location:</span>
                                                        <span
                                                            className = "pointer text-primary ml-2"
                                                            onClick = {() => {
                                                                setMapRangeKey(renderedForm.email + ","+ wk + "," + renderedDayIndex + "," + renderedIoIndex + ",in");
                                                            }}
                                                        >
                                                            {locationToAddress(renderedIo.inLocation)}
                                                        </span>
                                                        {(renderedForm.email + ","+ wk + "," + renderedDayIndex + "," + renderedIoIndex + ",in") === mapRangeKey?
                                                        <MapRange
                                                            closeIt = {() => {setMapRangeKey(m => "")}}
                                                            coords = {renderedIo.inLocation.slice(0, 2)}
                                                            accuracy = {renderedIo.inLocation[2]} 
                                                            url = {undefined}
                                                        />
                                                        :<></>}
                                                    </div>
                                                    :<></>}
                                                    {!renderedIo.m && renderedIo.inUserAgent?
                                                    <div className = "mt-2">
                                                        <span className = "font-weight-bold">Device:</span>
                                                        <span className = "ml-2">
                                                            {renderedIo.inUserAgent.indexOf("Windows") > -1?"Computer":"Mobile"}
                                                        </span>
                                                    </div>
                                                    :<></>}
                                                    <div className = "d-flex align-items-center mt-2">
                                                        <label htmlFor = {`${renderedDayIndex} ${renderedIoIndex} break`} className = "font-weight-bold text-nowrap mb-0">10-min break {renderedIoIndex + 1}:</label>
                                                        {isEdittingTime?
                                                        <input
                                                            id = {`${renderedDayIndex} ${renderedIoIndex} break`}
                                                            className = "cssCheckBox ml-2"
                                                            type = "checkbox"
                                                            step = "1"
                                                            checked = {renderedIo.break || false} 
                                                            onChange = {e => 
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                    allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                        ...io,break: e.currentTarget.checked
                                                                                    }:io)
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms)
                                                                )
                                                            }
                                                        />
                                                        :
                                                        <span className = {`ml-2 font-weight-bold text-${renderedIo.break?"info ":"danger"}`}>
                                                            {renderedIo.break?"yes":"no"}
                                                        </span>
                                                        }
                                                    </div>
                                                    {isEdittingTime?
                                                    <>
                                                        {testerEmails.includes(user.email)?
                                                        <>
                                                        <input
                                                            type = "time"
                                                            step = "1"
                                                            className = "mt-2 form-control"
                                                            value = {convertAMPM(renderedIo.in) ?? ""} 
                                                            min = {
                                                                renderedIoIndex > 0?
                                                                (
                                                                    renderedForm.form[renderedDayIndex].inOut[renderedIoIndex - 1].modifiedOut || 
                                                                    (new Date(
                                                                        "2021/05/21 " + renderedForm.form[renderedDayIndex].inOut[renderedIoIndex - 1].out)
                                                                    ).toLocaleTimeString(
                                                                        "en-US", { hour12: false }
                                                                    ) || ""
                                                                ):undefined
                                                            }
                                                            max = {renderedIo.modifiedOut || renderedIo.out}
                                                            onChange = {e => {
                                                                const newValue = e.currentTarget.value;
                                                                // Only convert to 12-hour format when input is complete
                                                                if (newValue && newValue.includes(":")) {
                                                                    setForms(
                                                                        forms.map(allForms => allForms[0].email === idid?
                                                                        allForms.map(form => form.week === wk?
                                                                        {
                                                                            ...form, 
                                                                            form: form.form.map(
                                                                                (
                                                                                    (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                    ({
                                                                                        ...day, 
                                                                                        inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                            ...io,in: convert24(newValue)
                                                                                        }:io)
                                                                                    }):day
                                                                                )
                                                                            )
                                                                        }:form):allForms)
                                                                    )
                                                                }
                                                            }}
                                                        />
                                                        <span
                                                            className = "btn btn-warning mt-2"
                                                            onClick = {() => 
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                        allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                        ...io, in: 
                                                                                            defaultForms.find(
                                                                                                form => form[0].email === idid
                                                                                            )?.find(
                                                                                                form => form.week === wk
                                                                                            )?.form?.find(
                                                                                                (day, dayIndex) => dayIndex === renderedDayIndex
                                                                                            )?.inOut?.find(
                                                                                                (io, ioIndex) => ioIndex === renderedIoIndex
                                                                                            )?.in
                                                                                    }:io)
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms)
                                                                )
                                                            }
                                                        >
                                                            Restore
                                                        </span>
                                                        </>
                                                        :<></>}
                                                        <input
                                                            type = "time"
                                                            step = "1"
                                                            className = "form-control text-danger mt-2"
                                                            value = {convertAMPM(renderedIo.modifiedIn) ?? ""} 
                                                            min = {
                                                                renderedIoIndex > 0?
                                                                (renderedForm.form[renderedDayIndex].inOut[renderedIoIndex - 1].modifiedOut || 
                                                                    (new Date(
                                                                        "2021/05/21 " + renderedForm.form[renderedDayIndex].inOut[renderedIoIndex - 1].out)
                                                                    ).toLocaleTimeString(
                                                                        "en-US", { hour12: false }
                                                                    ) || ""
                                                                ):undefined
                                                            }
                                                            max = {renderedIo.modifiedOut || renderedIo.out}
                                                            onChange = {e => {
                                                                const newValue = e.currentTarget.value;
                                                                // Only convert to 12-hour format when input is complete
                                                                if (newValue && newValue.includes(":")) {
                                                                    setForms(
                                                                        forms.map(allForms => allForms[0].email === idid?
                                                                        allForms.map(form => form.week === wk?
                                                                        {
                                                                            ...form, 
                                                                            form: form.form.map(
                                                                                (
                                                                                    (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                    ({
                                                                                        ...day, 
                                                                                        inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                            ...io,modifiedIn: convert24(newValue)
                                                                                        }:io)
                                                                                    }):day
                                                                                )
                                                                            )
                                                                        }:form):allForms)
                                                                    )
                                                                }
                                                            }}
                                                        />
                                                        {renderedIo.modifiedIn?
                                                        <textarea
                                                            className = "form-control text-danger mt-2"
                                                            value = {renderedIo.modifiedInNotes ?? ""}
                                                            onChange = {e => 
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                    allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                        ...io,modifiedInNotes: e.currentTarget.value
                                                                                    }:io)
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms)
                                                                )
                                                            }
                                                        />:<></>}
                                                        <span
                                                            className = "btn btn-warning mt-2"
                                                            onClick = {() => 
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                    allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                        ...io, modifiedIn: ""
                                                                                    }:io)
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms)
                                                                )
                                                            }
                                                        >
                                                            Clear
                                                        </span>
                                                        </>:<></>
                                                    }
                                                    <div className = "mt-2">
                                                        <span className = "font-weight-bold" style = {{color:renderedIo.m?"red":undefined}}>Out</span>: <span style = {{textDecoration: renderedIo.modifiedOut? "line-through":undefined}}>{renderedIo.out}</span>
                                                        {renderedIo.modifiedOut?<>
                                                            <span className = "text-danger ml-2">
                                                                {(new MyDate("2021/05/21 " + renderedIo.modifiedOut)).ss()}
                                                            </span>
                                                            {renderedIo.modifiedOutNotes?<div className = "text-danger cssNotes">
                                                                {renderedIo.modifiedOutNotes}
                                                            </div>:<></>}
                                                        </>:<></>}
                                                    </div>
                                                    {!renderedIo.m && renderedIo.outLocation?
                                                    <div className = "mt-2">
                                                        <span className = "font-weight-bold mt-2">Location:</span>
                                                        <span
                                                            className = "pointer text-primary ml-2"
                                                            onClick = {() => {
                                                                setMapRangeKey(renderedForm.email + ","+ wk + "," + renderedDayIndex + "," + renderedIoIndex + ",out");
                                                            }}
                                                        >
                                                            {locationToAddress(renderedIo.inLocation)}
                                                        </span>
                                                        {(renderedForm.email + ","+ wk + "," + renderedDayIndex + "," + renderedIoIndex + ",out") === mapRangeKey?
                                                        <MapRange
                                                            closeIt = {() => {setMapRangeKey(m => "")}}
                                                            coords = {renderedIo.inLocation.slice(0, 2)}
                                                            accuracy = {renderedIo.inLocation[2]} 
                                                            url = {undefined}
                                                        />
                                                        :<></>}
                                                    </div>
                                                    :<></>}
                                                    {!renderedIo.m && renderedIo.outUserAgent?
                                                    <div className = "mt-2">
                                                        <span className = "font-weight-bold">Device:</span>
                                                        <span className = "ml-2 text-danger">
                                                            {renderedIo.outUserAgent.indexOf("Windows") > -1?
                                                            "Computer":"Mobile"
                                                            }
                                                        </span>
                                                    </div>
                                                    :<></>}
                                                    {isEdittingTime?<>
                                                    {testerEmails.includes(user.email)?
                                                    <>
                                                    <input
                                                        type = "time"
                                                        step = "1"
                                                        min = {
                                                            renderedIo.modifiedIn || 
                                                            (
                                                                new Date("2021/05/21 " + renderedIo.in)
                                                            ).toLocaleTimeString(
                                                                "en-US", { hour12: false }
                                                            ) || ""
                                                        }
                                                        className = "form-control mt-2"
                                                        value = {convertAMPM(renderedIo.out) ?? ""}
                                                        onChange = {e => {
                                                            const newValue = e.currentTarget.value;
                                                            // Only convert to 12-hour format when input is complete
                                                            if (newValue && newValue.includes(":")) {
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                    allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                        ...io, 
                                                                                        out: convert24(newValue)
                                                                                    }:io)
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms)
                                                                )
                                                            }
                                                        }}
                                                    />
                                                    <span
                                                            className = "btn btn-warning mt-2"
                                                            onClick = {() => 
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                    allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                        ...io, out: 
                                                                                            defaultForms.find(
                                                                                                form => form[0].email === idid
                                                                                            )?.find(
                                                                                                form => form.week === wk
                                                                                            )?.form?.find(
                                                                                                (day, dayIndex) => dayIndex === renderedDayIndex
                                                                                            )?.inOut?.find(
                                                                                                (io, ioIndex) => ioIndex === renderedIoIndex
                                                                                            )?.out
                                                                                    }:io)
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms)
                                                                )
                                                            }
                                                        >
                                                            Restore
                                                        </span>
                                                    </>
                                                    :<></>}
                                                    <input
                                                        type = "time"
                                                        step = "1"
                                                        min = {
                                                            renderedIo.modifiedIn || 
                                                            (
                                                                new Date("2021/05/21 " + renderedIo.in)
                                                            ).toLocaleTimeString(
                                                                "en-US", { hour12: false }
                                                            ) || ""
                                                        }
                                                        className = "form-control text-danger mt-2"
                                                        value = {convertAMPM(renderedIo.modifiedOut) ?? ""}
                                                        onChange = {e => {
                                                            const newValue = e.currentTarget.value;
                                                            // Only convert to 12-hour format when input is complete
                                                            if (newValue && newValue.includes(":")) {
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                    allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                        ...io, modifiedOut: convert24(newValue)
                                                                                    }:io)
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms)
                                                                )
                                                            }
                                                        }}
                                                    />
                                                    {renderedIo.modifiedOut?
                                                    <textarea
                                                        className = "mt-2 form-control text-danger"
                                                        value = {renderedIo.modifiedOutNotes ?? ""}
                                                        onChange = {e => 
                                                            setForms(
                                                                forms.map(allForms => allForms[0].email === idid?
                                                                allForms.map(form => form.week === wk?
                                                                {
                                                                    ...form, 
                                                                    form: form.form.map(
                                                                        (
                                                                            (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                            ({
                                                                                ...day, 
                                                                                inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                    ...io,modifiedOutNotes: e.currentTarget.value
                                                                                }:io)
                                                                            }):day
                                                                        )
                                                                    )
                                                                }:form):allForms)
                                                            )
                                                        }
                                                    />:<></>}
                                                    <span className = "btn btn-warning mt-2" onClick = {() => {
                                                        setForms(
                                                            forms.map(allForms => allForms[0].email === idid?
                                                            allForms.map(form => form.week === wk?
                                                            {
                                                                ...form, 
                                                                form: form.form.map(
                                                                    (
                                                                        (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                        ({
                                                                            ...day, 
                                                                            inOut: day.inOut.map((io, ioIndex) => ioIndex === renderedIoIndex?{
                                                                                ...io, modifiedOut: ""
                                                                            }:io)
                                                                        }):day
                                                                    )
                                                                )
                                                            }:form):allForms))
                                                    }}>Clear</span>
                                                    </>:<></>}
                                                    {(renderedIo.duration === 0 || renderedIo.duration)?
                                                    <div className = "mt-2">
                                                        <span style = {{color:renderedIo.m?"red":undefined}}><strong>Duration</strong>: {renderedIo.duration} h</span>
                                                    </div>
                                                    :<></>}
                                                    <div className = "mt-2">
                                                        <span className = "font-weight-bold" style = {{color:renderedIo.m?"red":undefined}}>Notes:</span>
                                                        <span className = "ml-2 cssNotes" style = {{color:renderedIo.m?"red":undefined}}>{renderedIo.notes}</span>
                                                    </div>
                                                    {renderedIo.reports && renderedIo.reports.length?
                                                    <div className = "text-info mt-2">{renderedIo.reports.map((report, reportIndex) => <li key = {reportIndex}>{report.start} ~ {report.end} <Link to = {`/Reports/${report.reportHashKey}`}>{reportsList.find(item => item.value === report.reportHashKey)?.label}</Link></li>)}</div>
                                                    :<></>}
                                                    {isEdittingTime?
                                                    <div>
                                                        {renderedIo.m?<span className = "btn btn-danger mt-2" onClick = {() => {
                                                            if(!window.confirm("Are you sure to delete this?")) return;
                                                            setForms(
                                                                forms.map(allForms => allForms[0].email === idid?
                                                                allForms.map(form => form.week === wk?
                                                                {
                                                                ...form, 
                                                                form: form.form.map(
                                                                    (
                                                                        (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                        ({
                                                                            ...day, 
                                                                            inOut: [
                                                                                ...day.inOut.slice(0, renderedIoIndex),
                                                                                ...day.inOut.slice(renderedIoIndex + 1)
                                                                            ]
                                                                        }):day
                                                                    )
                                                                )
                                                                }:form):allForms))
                                                        }}>Delete This</span>:<></>}
                                                        <span className = "btn btn-success mt-2" onClick = {() => {
                                                                setForms(
                                                                    forms.map(allForms => allForms[0].email === idid?
                                                                    allForms.map(form => form.week === wk?
                                                                    {
                                                                        ...form, 
                                                                        form: form.form.map(
                                                                            (
                                                                                (day, dayIndex) => dayIndex === renderedDayIndex?
                                                                                ({
                                                                                    ...day, 
                                                                                    inOut: [
                                                                                        ...day.inOut.slice(0, renderedIoIndex + 1),
                                                                                        {m: true},
                                                                                        ...day.inOut.slice(renderedIoIndex + 1)
                                                                                    ]
                                                                                }):day
                                                                            )
                                                                        )
                                                                    }:form):allForms))
                                                            }}>Add To Below</span>
                                                    </div>
                                                    :<></>}
                                                    </div>)}
                                                    <div className = "mt-2">
                                                        <span className = "font-weight-bold">Summary:</span>
                                                        <span className = "ml-2">{renderedForm.form[renderedDayIndex].notes}</span>
                                                    </div>
                                                    {renderedForm.form[renderedDayIndex].inOut.map(item => item.reports || []).reduce(arrayReducer, []).length?
                                                    <div className = "mt-2 text-info">
                                                        <span className = "font-weight-bold">Reports Total:</span>
                                                        <span className = "ml-2">{(renderedForm.form[renderedDayIndex].inOut.map(item => item.reports || []).reduce(arrayReducer, []).map(obj => timeDurationCalc(obj.start, obj.end)).reduce(numberReducer, 0) / 60).toFixed(2)}h</span>
                                                    </div>
                                                    :<></>}
                                                    <div className = "my-2">
                                                        <span className = "font-weight-bold">Total:</span>
                                                        <span className = "ml-2">
                                                        {
                                                            renderedForm.form[renderedDayIndex].inOut.length && 
                                                            renderedForm.form[renderedDayIndex].inOut
                                                            .map(io => io.duration || 0)
                                                            .map(duration => round(duration, 2))
                                                            .reduce(numberReducer, 0).toFixed(2)
                                                        }h
                                                        </span>
                                                    </div>
                                                </div>)}
                                            </div>
                                            <div className = "font-weight-bold h5">
                                                Week Total: {renderedForm.form.map(v => v.inOut.length && v.inOut.map(io => io.duration || 0).reduce(numberReducer, 0)).reduce(numberReducer, 0).toFixed(2)}
                                            </div>
                                            <div className = "text-right">
                                                {isEdittingTime?
                                                <button
                                                    type = "submit"
                                                    value = "Submit"
                                                    className = "btn btn-warning"
                                                >
                                                    Save Time
                                                </button>
                                                :
                                                <>
                                                <span className = "btn btn-warning"
                                                    onClick = {async() => {
                                                        setForms(forms.map(allForms => allForms[0].email === idid?
                                                        allForms.map(form => form.week === wk?
                                                            {
                                                                ...form, ...(fD())
                                                            }:form):allForms
                                                        ));
                                                        setIsEdittingTime(true);
                                                    }}
                                                >
                                                    Edit Time
                                                </span>
                                                {renderedForm.status === "Created"?
                                                <span className = "btn btn-primary ml-2"
                                                    onClick = {async() => {
                                                        //-------------------------------------------------------------
                                                        const problemNumbers = renderedForm.form
                                                        .map(day => day.inOut.filter(io => io.duration === undefined).length);
                                                        if(problemNumbers.reduce(numberReducer, 0)){
                                                            const problemNumberIndexes = problemNumbers
                                                            .map((problemNumber, problemNumberIndex) => problemNumber > 0?problemNumberIndex:-1)
                                                            .filter(problemNumberIndex => problemNumberIndex !== -1).map(problemNumberIndex => weekDays[problemNumberIndex]);
                                                            window.alert(`${problemNumberIndexes.join(", ")} ${problemNumberIndexes.length > 1?"are":"is"} missing In or Out`);
                                                            return;
                                                        }
                                                        
                                                        for(let thisDayIndex = 0; thisDayIndex < renderedForm.form.length; thisDayIndex++){
                                                            if(renderedForm.form[thisDayIndex].inOut.some(io => io.duration === undefined)){
                                                                window.alert("You missed at least one in or out.");
                                                                return;
                                                            }
                                                        }
                                                        const problemNumbers2 = renderedForm.form
                                                        .map(day => 
                                                            day.inOut.length && 
                                                            day.inOut.filter(io => io.break).length < 
                                                            Math.floor(
                                                                day.inOut.map(io => io.duration).reduce(numberReducer, 0) / 4
                                                            )
                                                        );
                                                        if((problemNumbers2.reduce(numberReducer , 0) && user.outside !== "runner") || testerEmails.includes(user.email)){
                                                            const problemNumberIndexes2 = problemNumbers2
                                                            .map((problemNumber, problemNumberIndex) => problemNumber > 0?problemNumberIndex:-1)
                                                            .filter(problemNumberIndex => problemNumberIndex !== -1).map(problemNumberIndex => weekDays[problemNumberIndex]);
                                                            window.alert(`${problemNumberIndexes2.join(", ")} ${problemNumberIndexes2.length > 1?"are":"is"} missing 10-min break(s).`);
                                                            if(!window.confirm("Still submit?")) return;
                                                        }
                                                        if(!window.confirm("Are you sure to submit for the week?")) return;
                                                        //-------------------------------------------------------------
                                                        const formData = new MyFormData();
                                                        formData.append("userEmail", renderedForm.email);
                                                        formData.append("laborName", renderedForm.userName);
                                                        formData.append("currentWeek", wk);
                                                        formData.append("we", getDateEndFromWeekNum(wk));
                                                        const regOT = (day, dayIndex) => {
                                                            if(day.inOut.length > 0){
                                                                const totalHours = (day.inOut.map(io => io.duration).reduce(numberReducer, 0));
                                                                let regular = totalHours > 8 ? 8 : totalHours;
                                                                let ot = totalHours > 8 ? totalHours - 8 : 0;
                                                                if(dayIndex > 4){
                                                                    regular = 0;
                                                                    ot = totalHours;
                                                                }
                                                                return {regular: regular, ot: ot}
                                                            }else{
                                                                return {regular: 0, ot: 0}
                                                            }
                                                        };
                                                        formData.append("data", JSON.stringify(
                                                            {
                                                                ...renderedForm, 
                                                                form: renderedForm.form.map((day, dayIndex) => ({
                                                                    ...day, 
                                                                    date: getDatefromWeekNum(renderedForm.week, dayIndex), 
                                                                    regular: regOT(day, dayIndex).regular, 
                                                                    ot: regOT(day, dayIndex).ot
                                                                })),
                                                                status: "Submitted"
                                                            }
                                                        ));
                                                        formData.append("form", "office");
                                                        //----------------------------------------------------------------
                                                        setShowLoader(true);
                                                        const res = await myAxios("timeCard/updateTimeCard.php", formData);
                                                        setShowLoader(false);
                                                        if(!res) return;
                                                        //----------------------------------------------------------------
                                                        setForms(forms.map(allForms => allForms[0].email === idid?
                                                        allForms.map(form => form.week === wk?
                                                        {
                                                            ...form, 
                                                            status: "Submitted", 
                                                            id: res.data
                                                        }:form):allForms
                                                        ));
                                                        history.replace(`/${title}/${wk}`);
                                                    }}
                                                >
                                                    Submit for the week
                                                </span>
                                                :<></>}
                                                </>}
                                            </div>
                                            {renderedForm.status === "Submitted"?
                                            <div className = "text-right">
                                                <div className = "text-left font-weight-bold">Approver Comments</div>
                                                <textarea
                                                    className = "form-control"
                                                    onChange = {e => setComments(e.currentTarget.value)}
                                                    value = {comments}
                                                />
                                                <span className = "btn btn-primary mt-2"
                                                    onClick = {async() => {
                                                        if(!window.confirm("Are you sure to approve?")) return;
                                                        const thisForm = forms.find(allForms => allForms[0].email === idid).find(form => form.week === wk);
                                                        const formData = new MyFormData();  
                                                        formData.append("currentWeek", wk);
                                                        formData.append("we", getDateEndFromWeekNum(wk));
                                                        formData.append("decision", "Approved");
                                                        formData.append("userName", thisForm.userName);
                                                        formData.append("userEmail", thisForm.email);
                                                        formData.append("outside", thisForm.outside);
                                                        formData.append("approvalComments", comments);
                                                        formData.append("data", JSON.stringify({...thisForm, status: "Approved", comments: comments}));
                                                        //----------------------------------------------------------------
                                                        setShowLoader(true);
                                                        const res = await myAxios( "timeCard/updateTimeCard.php", formData);
                                                        setShowLoader(false);
                                                        if(!res) return;
                                                        //----------------------------------------------------------------
                                                        setForms(
                                                            forms.map(allForms => allForms[0].email === idid?
                                                            allForms.map(form => form.week === wk?
                                                            {
                                                                ...form, 
                                                                status: "Approved"
                                                            }:form):allForms
                                                            )
                                                        )
                                                        history.replace(`/${title}/${wk}`);
                                                    }}
                                                >
                                                    Approve
                                                </span>
                                                <span className = "btn btn-danger mt-2 ml-2"
                                                    onClick = {async() => {
                                                        if(!window.confirm("Are you sure to reject?")) return;
                                                        const thisForm = forms.find(allForms => allForms[0].email === idid).find(form => form.week === wk);
                                                        const formData = new MyFormData();    
                                                        formData.append("currentWeek", wk);
                                                        formData.append("we", getDateEndFromWeekNum(wk));
                                                        formData.append("decision", "Rejected");
                                                        formData.append("userEmail", thisForm.email);
                                                        formData.append("approvalComments", comments);
                                                        formData.append("data", JSON.stringify({...thisForm, status: "Rejected", comments: comments}));
                                                        //----------------------------------------------------------------
                                                        setShowLoader(true);
                                                        const res = await myAxios("timeCard/updateTimeCard.php", formData);
                                                        setShowLoader(false);
                                                        if(!res) return;
                                                        //----------------------------------------------------------------
                                                        setForms(
                                                            forms.map(allForms => allForms[0].email === idid?
                                                            allForms.map(form => form.week === wk?
                                                            {
                                                                ...form, 
                                                                status: "Rejected"
                                                            }:form):allForms
                                                            )

                                                        )
                                                        history.replace(`/${title}/${wk}`);
                                                    }}
                                                >
                                                    Reject
                                                </span>
                                            </div>:<></>}
                                        </form>
                                        </TransitionWidthHeight>
                                    </td>
                                </tr>
                                </Fragment>
                                )}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredValidForms.length?
                <Footer
                    length = {filteredValidForms.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}